module.exports = __webpack_public_path__ + "static/media/pomu.a24df06b.mp3";